import { themeColors } from "@/utils/themeColors";
import { Language } from "@knowt/syncing/graphql/schema";
import { capitalize } from "@knowt/syncing/utils/stringUtils";
import { FLASHCARD_LANGUAGES, REMOVED_LANGUAGES } from "@knowt/syncing/hooks/flashcards/languageUtils";
import InputWithMenu from "@/components/InputWithMenu";
import { SxProps } from "@mui/material/styles";

const getLangLabel = (lang: Language) => {
    return lang.toLowerCase().split("_").map(capitalize).join(" ");
};

const LanguageAutocomplete = ({
    initialLanguage,
    onChange,
    sx,
}: {
    initialLanguage: Language;
    onChange: ({ language }: { language: Language }) => void;
    sx?: SxProps;
}) => {
    const flashcardLangs = Object.values(FLASHCARD_LANGUAGES)
        .filter(lang => !REMOVED_LANGUAGES.has(lang))
        .map(lang => ({ label: getLangLabel(lang), value: lang as Language }));

    return (
        <InputWithMenu
            inputProps={{
                sx: {
                    border: `1px solid ${themeColors.neutralBlack}`,
                    borderRadius: "999px",
                    height: "4.8rem",
                    backgroundColor: "transparent",
                    padding: "0 1.5rem",
                    width: "30rem",
                    fontSize: "1.6rem",
                    ...sx,
                },
            }}
            ulProps={{ sx: { backgroundColor: themeColors.background, borderRadius: "1.2rem", top: "5.6rem" } }}
            useAutocompleteProps={{
                options: flashcardLangs,
                value: { label: getLangLabel(initialLanguage), value: initialLanguage },
                onChange: (_, newValue, reason) => {
                    if (reason === "selectOption") {
                        if (newValue) {
                            onChange({ language: newValue.value });
                        }
                    }
                },
            }}
        />
    );
};

export default LanguageAutocomplete;
